import React from 'react';
import {FormattedMessage} from 'react-intl';
import {trMessages} from './tr-messages';

import addSoundCheckpoints from '../icons/icon--add-sound-checkpoints.svg';
import askForHelp from '../icons/icon--ask-for-help.svg';
import breakItDown from '../icons/icon--break-it-down.svg';
import checkCodeSequence from '../icons/icon--check-code-sequence.svg';
import checkTheValues from '../icons/icon--check-the-values.svg';
import commentYourCode from '../icons/icon--comment-your-code.svg';
import readAloud from '../icons/icon--read-aloud.svg';
import slowItDown from '../icons/icon--slow-it-down.svg';
import takeABreak from '../icons/icon--take-a-break.svg';
import thinkAboutBlockOptions from '../icons/icon--think-about-block-options.svg';
import timingAndParallelism from '../icons/icon--timing-and-parallelism.svg';
import tinkerWithBlockOrder from '../icons/icon--tinker-with-block-order.svg';
import toLoopOrNotToLoop from '../icons/icon--to-loop-or-not.svg';

// Türkçe içeriği doğrudan kullanıyoruz
export const sections = [
    {
        id: 'readAloud',
        title: 'Sesli Oku',
        description: <div>
            <p>Kodunuzu sesli okurken, bilgisayarın bakış açısından düşünün.</p>
            <ul>
                <li>Var olmayan adımları dahil ediyor musunuz?</li>
                <li>Talimatlarınız açık mı?</li>
                <li>Program her çalıştığında bir şeyin sıfırlanması gerekiyorsa, bu talimatlar dahil edilmiş mi?</li>
            </ul>
        </div>,
        image: readAloud
    }, {
        id: 'breakItDown',
        title: 'Parçalara Ayır',
        description: (<div>
            <p>Blokları daha küçük parçalara (veya dizilere) ayırın ve her dizinin ne yaptığını görmek için tıklayın.</p>
            <p>Daha küçük diziler beklediğiniz gibi çalışınca, bunları ana programa geri ekleyin.</p>
            <p>Bu işleme ayrıştırma denir.</p>
        </div>),
        image: breakItDown
    }, {
        id: 'slowItDown',
        title: 'Yavaşlat',
        description: (<div>
            <p>Bilgisayar programınızı gözlerinizle takip etmesi zor olacak kadar hızlı çalıştırır.</p>
            <p>Dizileri yavaşlatmak için geçici "bekle" veya "bekle" blokları ekleyin. Bu, bir parçanın çalışıp çalışmadığını görmek için size zaman tanır.</p>
            <p>Kodunuz çalışır hale gelince bu bekle bloklarını kaldırın.</p>
        </div>),
        image: slowItDown
    }, {
        id: 'addSoundCheckpoints',
        title: 'Ses Kontrol Noktaları Ekle',
        description: (<div>
            <p>Yavaşlatma stratejisine benzer şekilde, dizinizi test etmek için anahtar noktalara "bitene kadar çal" bloğu ile farklı sesler ekleyebilirsiniz.</p>
            <p>Bir ses çalmazsa, hatanız bu bloktan önce olabilir. Ses çalıyorsa, hata muhtemelen bu bloktan sonradır.</p>
            <p>Kodunuz çalışır hale gelince sesleri kaldırın.</p>
        </div>),
        image: addSoundCheckpoints
    }, {
        id: 'tinkerWithBlockOrder',
        title: 'Blok Sırasını Değiştir',
        description: <div>
            <p>Blokların sırasını/dizisini ayarlamayı deneyin.</p>
            <ul>
                <li>Önce ne olması gerekiyor?</li>
                <li>İkinci olarak ne oluyor?</li>
                <li>Bir sonraki kod çalışmadan önce değerlerin veya kuklalar sıfırlanması gerekiyor mu?</li>
            </ul>
            <p>Blokları bir döngü veya koşullu ifade içinde kullanmayı, döngü veya koşullu ifade dışında kullanmaya karşı deneyin.</p>
        </div>,
        image: tinkerWithBlockOrder
    }, {
        id: 'toLoopOrNotToLoop',
        title: 'Döngü Kullanmak ya da Kullanmamak',
        description: (<div>
            <p>"Sürekli" ve "tekrarla" gibi Kontrol blokları kullanıyorsanız, bir döngü içindeki tüm blokların orada olması gerekip gerekmediğini veya işlemi sıfırlamak veya zamanlamayı ayarlamak için bir bloğun (örneğin "bekle") eksik olup olmadığını kontrol edin. Döngünüzün sonsuza kadar mı yoksa belirli sayıda kez mi çalışmasını istiyorsunuz? Döngülemeyi durduracak bir şey olmalı mı?</p>
            <p>Belki de kullanmanız gereken bir döngü kullanmıyorsunuz? Örneğin, "eğer o zaman" gibi bir koşullu ifade bloğu kullanıyorsanız, program bunun doğru mu yanlış mı olduğunu yalnızca bir kez mi kontrol etmeli? Yoksa sürekli olarak kontrol etmesi mi gerekiyor, bu durumda koşullu ifadenizi sonsuz bir döngü içine mi koymak istersiniz?</p>
        </div>),
        image: toLoopOrNotToLoop
    }, {
        id: 'timingAndParallelism',
        title: 'Zamanlama ve Paralellik Üzerine Düşün',
        sectionTitle: 'Zamanlama ve Paralellik',
        description: (<div>
            <p>Aynı anda çalışmaya çalışan birden fazla olayınız var mı? İki dizi aynı anda başlayacak şekilde programlandıysa, tahmin edilemeyen davranışlar elde edebilirsiniz.</p>
            <p>Bunun sonucu etkileyip etkilemediğini görmek için küçük beklemeler, yayınlar veya kullanıcı etkileşimi (tıklama veya bir tuşa basma gibi) ekleyin.</p>
        </div>),
        image: timingAndParallelism
    }, {
        id: 'thinkAboutBlockOptions',
        title: 'Blok Seçenekleri Üzerine Düşün',
        description: (<div>
            <p>Kullanabileceğiniz benzer ama farklı bir blok var mı?</p>
            <p>Bazı bloklar benzer görünür ancak farklı davranabilir, örneğin "ayarla" ve "değiştir" veya "bitene kadar çal" ve "başlat" gibi.</p>
            <p>Sahip olduğunuzun yerine benzer bir blok kullanmayı deneyin ve bunun sonucu etkileyip etkilemediğini görün.</p>
        </div>),
        image: thinkAboutBlockOptions
    }, {
        id: 'checkTheValues',
        title: 'Değerleri Kontrol Et',
        description: <div>
            <p>Değişkenler veya raportör blokları kullanıyorsanız, kod dizisi çalıştırıldığı anda değeri kontrol edin.</p>
            <ul>
                <li>Tüm kuklaların bir değişkeni kontrol etmesi mi gerekiyor, yoksa sadece bir kuklanın mı kontrolü olmalı?</li>
                <li>Değer nerede sıfırlanıyor? Nerede değiştiriliyor?</li>
            </ul>
        </div>,
        image: checkTheValues
    }, {
        id: 'checkCodeSequence',
        title: 'Kod Dizisini Kontrol Et',
        description: <div>
            <p>Kod dizinizin doğru kuklaya veya uygunsa arka plana eklendiğinden emin olun.</p>
            <p>Kodunuzu başka bir kuklaya taşımanız gerekiyorsa, doğru kuklanın üzerinde gezinene kadar tıklayıp sürükleyin. Kukla sallanınca bırakın.</p>
            <p>Kodunuzu veya varlıklarınızı saklamak ve taşımak için Sırt Çantanızı da (ekranın altında) kullanabilirsiniz.</p>
        </div>,
        image: checkCodeSequence
    }, {
        id: 'commentYourCode',
        title: 'Kodunuzu Yorumlayın',
        description: <div>
            <p>Kodunuza yorum eklemek, kodunuza bakan diğer kişilerin onu anlamasına yardımcı olabilir. Ayrıca daha sonra kodunuza döndüğünüzde nasıl çalıştığını hatırlamanıza da yardımcı olabilir.</p>
            <p>Kodunuzu bölümlere ayırmak ve her bölümün ne yaptığını açıklamak yararlı olabilir.</p>
        </div>,
        image: commentYourCode
    }, {
        id: 'takeABreak',
        title: 'Ara Ver',
        description: <div>
            <p>Bazen en iyi yaklaşım, ara vermek ve kafa temizliğidir!</p>
            <p>Daha sonra projene taze bir bakış açısıyla dönebilirsin.</p>
        </div>,
        image: takeABreak
    }, {
        id: 'askForHelp',
        title: 'Yardım İste',
        description: <div>
            <p>Bir arkadaştan, öğretmenden veya aile üyesinden yardım istemekten çekinme.</p>
            <p>Bazen yeni bir bakış açısı, göremediğiniz sorunları görmenize yardımcı olabilir.</p>
        </div>,
        image: askForHelp
    }
];
